import React from "react";
import { Navigate } from "react-router-dom";
import { ROUTES } from "@/constants";
import { useAuth } from "@/hooks";
import { canAccessRoute } from "@/utils";
import type { UserRole } from "@/types";

interface RequireRoleProps {
  roles: UserRole[];
  children: React.ReactNode;
}

/**
 * Restricts access to users with allowed roles
 */
export const RequireRole: React.FC<RequireRoleProps> = ({
  roles,
  children,
}) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <p>Cargando...</p>;
  }

  if (!user || !roles.includes(user.role)) {
    return <Navigate to={ROUTES.backoffice.login} replace />;
  }

  if (!canAccessRoute(user.role, window.location.pathname)) {
    return <Navigate to={ROUTES.backoffice.login} replace />;
  }

  return <>{children}</>;
};
